/* Breasties scratch card pop-up.
   Opens once per visitor (after a delay, a scroll depth or exit intent),
   lets them scratch a foil panel to reveal a prize, then collects an email.
   The discount code is never on the page: it arrives in the welcome email. */
(function () {
  var root = document.querySelector('[data-bz-scratch]');
  if (!root) return;
  var KEY = 'bzScratch', d = root.dataset;
  var design = d.design === '1', posted = d.posted === '1';
  var prizes = [];
  try { prizes = JSON.parse(document.querySelector('[data-bz-prizes]').textContent); } catch (e) {}
  if (!prizes.length) return;

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(KEY) || '{}');
      localStorage.setItem(KEY, JSON.stringify(val));
    } catch (e) { return {}; }
  }
  var state = store(true) || {};

  // Pick (or recall) this visitor's prize, by weight.
  function pick() {
    if (state.prize != null && prizes[state.prize]) return state.prize;
    var total = prizes.reduce(function (a, p) { return a + (+p.weight || 1); }, 0), r = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) { r -= (+prizes[i].weight || 1); if (r <= 0) return i; }
    return 0;
  }
  var idx = pick(), prize = prizes[idx];
  function paint() {
    root.querySelectorAll('[data-prize-title]').forEach(function (e) { e.textContent = prize.title; });
    root.querySelectorAll('[data-prize-sub]').forEach(function (e) { e.textContent = prize.sub; });
    var note = root.querySelector('[data-bz-note]');
    if (note) note.value = 'Scratch card: ' + prize.title;
  }
  paint();

  function step(name) {
    root.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.dataset.step !== name; });
    if (name === 'claim') setTimeout(function () { var i = root.querySelector('#BzScratchEmail'); if (i) i.focus(); }, 60);
  }
  var lastFocus = null, opened = false;
  function open(force) {
    if (opened && !force) return;
    opened = true; lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('bz-scr-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); setupFoil(); });
    if (!design) { state.seen = Date.now(); state.prize = idx; store(false, state); }
    var x = root.querySelector('.bz-scr__x'); if (x) x.focus();
  }
  function close() {
    root.classList.remove('is-open'); document.documentElement.classList.remove('bz-scr-lock');
    setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-bz-scratch-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // ---------- scratch foil ----------
  var canvas = root.querySelector('[data-bz-foil]'), ctx, done = false, drawing = false, last = null, ready = false;
  function setupFoil() {
    if (ready || !canvas) return;
    var box = canvas.parentNode.getBoundingClientRect(); if (!box.width) return;
    ready = true;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = box.width * dpr; canvas.height = box.height * dpr;
    ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
    var w = box.width, h = box.height, cs = getComputedStyle(root);
    var foil = (cs.getPropertyValue('--bz-scr-foil') || '').trim();
    // gold foil: metallic gradient, a soft sheen band and fine glitter
    if (foil && foil !== 'gold') { ctx.fillStyle = foil; ctx.fillRect(0, 0, w, h); }
    else {
      var gold = ctx.createLinearGradient(0, 0, w, h);
      gold.addColorStop(0, '#B8872C'); gold.addColorStop(.22, '#E9C76E'); gold.addColorStop(.42, '#F8E6A8');
      gold.addColorStop(.58, '#D9AE52'); gold.addColorStop(.8, '#F1D488'); gold.addColorStop(1, '#A97A24');
      ctx.fillStyle = gold; ctx.fillRect(0, 0, w, h);
    }
    var sheen = ctx.createLinearGradient(0, h, w, 0);
    sheen.addColorStop(.35, 'rgba(255,255,255,0)'); sheen.addColorStop(.5, 'rgba(255,255,255,.35)'); sheen.addColorStop(.65, 'rgba(255,255,255,0)');
    ctx.fillStyle = sheen; ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = 'rgba(255,255,255,.08)'; ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 6) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
    for (var i = 0; i < 420; i++) {
      ctx.fillStyle = Math.random() < .5 ? 'rgba(255,255,255,' + (Math.random() * .6).toFixed(2) + ')' : 'rgba(120,80,20,' + (Math.random() * .25).toFixed(2) + ')';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.4, 1.4);
    }
    ctx.strokeStyle = 'rgba(255,255,255,.55)'; ctx.lineWidth = 2; ctx.setLineDash([6, 6]);
    ctx.strokeRect(10, 10, w - 20, h - 20); ctx.setLineDash([]);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = Math.max(34, w * .09);
  }
  function pos(e) {
    var b = canvas.getBoundingClientRect(), t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - b.left, y: t.clientY - b.top };
  }
  function scratch(p) {
    ctx.beginPath();
    if (last) { ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
    ctx.arc(p.x, p.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill();
    last = p;
  }
  var checkT;
  function cleared() {
    var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0, n = 0;
    for (var i = 3; i < data.length; i += 64) { n++; if (data[i] < 40) clear++; }
    return clear / n;
  }
  function reveal() {
    if (done) return; done = true;
    canvas.classList.add('is-gone');
    root.querySelector('[data-bz-hint]').classList.add('is-gone');
    root.querySelector('[data-bz-scratch-card]').classList.add('is-won');
    state.revealed = true; if (!design) store(false, state);
    setTimeout(function () { step('claim'); }, 1100);
  }
  if (canvas) {
    var start = function (e) { if (done || !ctx) return; drawing = true; last = null; root.querySelector('[data-bz-hint]').classList.add('is-gone'); scratch(pos(e)); e.preventDefault(); };
    var move = function (e) {
      if (!drawing || done) return; scratch(pos(e)); e.preventDefault();
      clearTimeout(checkT); checkT = setTimeout(function () { if (cleared() > .45) reveal(); }, 80);
    };
    var end = function () { drawing = false; last = null; if (!done && ctx && cleared() > .45) reveal(); };
    canvas.addEventListener('mousedown', start); canvas.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move); canvas.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', end); window.addEventListener('touchend', end);
  }
  var rv = root.querySelector('[data-bz-reveal]');
  if (rv) rv.addEventListener('click', reveal);

  // ---------- claim ----------
  // Posts the Shopify customer form (tagged "newsletter"), which subscribes
  // them and starts the Judge.me Email welcome flow. The page reloads to the
  // "check your inbox" step.
  var form = document.getElementById('BzScratchForm');
  if (form) form.addEventListener('submit', function () {
    state.claimed = true; state.prize = idx; if (!design) store(false, state);
  });

  // ---------- when to open ----------
  if (posted) { idx = state.prize != null ? state.prize : idx; prize = prizes[idx] || prize; paint(); step('code'); open(true); return; }
  if (design) {
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(true); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    return;
  }
  var days = (+d.days || 14) * 864e5;
  if (state.claimed || (state.seen && Date.now() - state.seen < days)) return;
  if (+d.delay > 0) setTimeout(open, +d.delay * 1000);
  if (+d.scroll > 0) window.addEventListener('scroll', function onS() {
    var p = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
    if (p >= +d.scroll) { window.removeEventListener('scroll', onS); open(); }
  }, { passive: true });
  if (d.exit === 'true') document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
})();
